module.exports = __webpack_public_path__ + "static/img/404.16bf7149.png";